/** @format */
import { useEffect, useState } from 'react';

/**
 * @deprecated use Feather/hooks/use-window-resize-callback instead
 *
 * A hook that will fire a callback when the window size changes
 *
 * @param callback Callback to be called when the window size changes
 */
export const useWindowResizeCallback = (callback: () => void) => {
    useEffect(() => {
        let queued = false;

        const handleResize = () => {
            if (queued) {
                return;
            }

            queued = true;
            window.requestAnimationFrame(function () {
                callback();
                queued = false;
            });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [callback]);
};

/**
 * @deprecated use Feather/hooks/use-window-resize instead
 */
export const useWindowResize = () => {
    const [dimensions, setDimensions] = useState([
        typeof window !== 'undefined' ? window.innerWidth : 0,
        typeof window !== 'undefined' ? window.innerHeight : 0,
    ]);

    useWindowResizeCallback(() => {
        setDimensions([window.innerWidth, window.innerHeight]);
    });

    return dimensions;
};
